import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import "./css/BannerSection.css";

const BannerSection = () => {
  const [destination, setDestination] = useState("");
  const [isAutoSuggestVisible, setIsAutoSuggestVisible] = useState(false);
  const [trendingDestinations, setTrendingDestinations] = useState([]);
  const [filteredDestinations, setFilteredDestinations] = useState([]);

  const bgImage = "/Images/tour/plenary-main-banner-img.jpeg";


  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const response = await fetch("https://admin.new.plenaryholidays.com/api/HolidayPackages/destinations");
        const result = await response.json();
        if (result.success) {
          setTrendingDestinations(result.data);
        }
      } catch (error) {
        console.error("Error fetching destinations:", error);
      }
    };
    fetchDestinations();
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setDestination(value);
    if (value.trim() === "") {
      setFilteredDestinations([]);
      return;
    }
    const filtered = trendingDestinations.filter((dest) =>
      dest.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredDestinations(filtered);
    setIsAutoSuggestVisible(true);
  };

  const handleDestinationSelect = (dest) => {
    setDestination(dest.name);
    setIsAutoSuggestVisible(false);
    setFilteredDestinations([]);
    window.location.href = `/${dest.slug}`;
  };

  const handleSearchClick = () => {
    if (destination.trim() === "") return;
    const matched = trendingDestinations.find(
      (dest) => dest.name.toLowerCase() === destination.toLowerCase()
    );
    if (matched) {
      window.location.href = `/${matched.slug}`;
    } else {
      window.location.href = `/${destination.replace(/\s+/g, "-").toLowerCase()}`;
    }
  };

  const loadAppzi = () => {
  if (document.getElementById("appzi-script")) {
    // Script already loaded → directly open widget
    if (window.Appzi) {
      window.Appzi.open();
    }
    return;
  }

  const script = document.createElement("script");
  script.id = "appzi-script";
  script.src = "https://app.appzi.io/bootstrap/bundle.js?token=TyNip";
  script.async = true;

  script.onload = () => {
    if (window.Appzi) {
      window.Appzi.open();
    }
  };

  document.body.appendChild(script);
};


  return (
    <>
    <div
      className="hero-main hero-single"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="hero-mask">
        <Container>
          <div className="hero-content">
            <span className="hero-badge">Trusted Holiday Experts</span>

            <h1>
              Curated Holidays & Corporate Travel Experiences
              {/* Discover Your <br /> Perfect Holiday */}
            </h1>

            <p>Domestic & International Tours | MICE | Group & Corporate Travel Specialists</p>

            <div className="hero-search-box">
                        <input
                          type="text"
                          placeholder="Enter Your Dream Destination!"
                          autoComplete="off"
                          value={destination}
                          onChange={handleInputChange}
                          onFocus={() => {
                            setIsAutoSuggestVisible(true);
                            if (destination.trim() === "") {
                              setFilteredDestinations(trendingDestinations);
                            }
                          }}
                          onBlur={() => setTimeout(() => setIsAutoSuggestVisible(false), 200)}
                        />
                        <button className="subm_btn" type="button" onClick={handleSearchClick}>
                          Explore Holidays
                        </button>
                    {isAutoSuggestVisible && filteredDestinations.length > 0 && (
                      <div className="auto_sgtn">
                        <div className="d-flex align-items-center" style={{ padding: "10px 15px", gap: "15px" }}>
                          <img
                            src="https://images.emtcontent.com/holiday-img/home-img/cir_loc.svg"
                            alt="location"
                          />
                          <span>
                            <strong>Top Trending</strong> Holiday Destinations
                          </span>
                        </div>
                        <ul className="auto_sgtn_ul">
                          {filteredDestinations.map((dest, index) => (
                            <li key={index} className="d-flex align-items-center" onClick={() => handleDestinationSelect(dest)}>
                              <a className="d-flex align-items-center">
                                <div className="img_box ulimg">
                                  <img
                                    src={dest.image}
                                    alt={dest.name}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = "https://images.emtcontent.com/holiday-img/home-img/city-100x.png";
                                    }}
                                  />
                                </div>
                                <div className="cont">
                                  <p>{dest.name}</p>
                                </div>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
            </div>
          </div>

          <div className="hero-form">
            <h4>Request a Call Back</h4>
            <form>
              <input type="text" placeholder="Your Name" />
              <input type="tel" placeholder="Mobile No" />
              <input type="email" placeholder="Mail Id" />
              <textarea placeholder="Message"></textarea>
              <button type="submit">Plan a MICE Event</button>
            </form>
          </div>
        </Container>
      </div>
    </div>
    {/* Sticky Feedback Button */}
    <div className="feedback-sticky" onClick={loadAppzi}>
    </div>

    </>
  );
};

export default BannerSection;
